import { css } from '@emotion/react'

import { customCss, nProgressCss } from './globalCss'

export const globalStyles = css`
  ${customCss};
  ${nProgressCss};
`
